import React from 'react';
import { Path, Svg } from 'react-native-svg';
import type { IconProps } from './types';

export const AddIcon: React.FC<IconProps> = ({
  size = 16,
  color = '#020202',
  ...props
}) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <Path d="M0 8H16M8 0V16" stroke={color} strokeWidth="1.5" strokeLinejoin="round" />
  </Svg>
);

AddIcon.displayName = 'AddIcon';
